import { Mail, Phone, X } from "lucide-react";

const Contact = ({ onClose, data }) => {
  const getInitials = (name) => {
    if (!name) return "NA";

    const parts = name.trim().split(" ").filter(Boolean);

    if (parts.length === 1) {
      // single name → first 2 letters
      return parts[0].slice(0, 2).toUpperCase();
    }

    // otherwise → first two words ka first letter
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[30%]  bg-white">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">Contact</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="w-[90%] mx-auto my-5">
            <div className="flex items-center gap-4 mb-4 border-b border-black/10 pb-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-r from-[#0f172a] to-[#1E293B] text-white flex items-center justify-center text-xl font-bold">
                {getInitials(data.clientName)}
              </div>
              <div>
                <h3 className="font-semibold text-lg text-gray-900">
                  {data.clientName}
                </h3>
                <div className="flex gap-2 text-xs mt-1">
                  {data.roles.map((type, i) => (
                    <span
                      key={i}
                      className="bg-gray-100 text-gray-600 px-2 py-0.5 rounded"
                    >
                      {type.role}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-x-3 border-b border-black/10 pb-3">
              <a
                href={`tel:${data.phone}`}
                className="flex items-center gap-x-3"
              >
                <div className="bg-gray-100 rounded-full p-3">
                  <Phone size={18} />
                </div>
                <p className="font-medium text-base">{data.phone}</p>
              </a>
            </div>

            <div className="flex items-center gap-x-3 pb-3 mt-3">
              <a
                href={`mailto:${data.email}`}
                className="flex items-center gap-x-3"
              >
                <div className="bg-gray-100 rounded-full p-3">
                  <Mail size={18} />
                </div>
                <p className="font-medium text-base">{data.email}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
